import { resolveCdnAssetUrl } from "./cdnAssetUrl";

function isBareManagedAssetPath(src: string): boolean {
  if (src.includes("://") || src.startsWith("/")) {
    return false;
  }

  // Matches values like "home/focus.svg" or "logo_github.svg".
  return /^[a-zA-Z0-9][a-zA-Z0-9/_ .-]*\.[a-zA-Z0-9]+$/.test(src);
}

/**
 * Resolves managed image asset paths to canonical CDN URLs.
 * Absolute or root-relative URLs pass through unchanged.
 */
export function resolveAssetUrl(src: string): string {
  if (isBareManagedAssetPath(src)) {
    return resolveCdnAssetUrl(src);
  }

  return src;
}
